@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: dark from "../../styles/theming.module.css";
}

.mainContentContainer {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    @media print {
        display: none !important;
    }
}

.inner {
    grid-column: 3 / span 8;
    padding-top: var(--spacer-32);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }

    [data-design-version="v2026"] & {
        grid-column: 1 / -1;
        display: grid;
        grid-template-columns: subgrid;
        padding-top: 0;

        > * {
            grid-column: 1 / -1;
            padding-inline: var(--spacer-40);
        }

        @media ($below-mobile) {
            > * {
                padding-inline: var(--spacer-16);
            }
        }
    }
}
